module.exports = __webpack_public_path__ + "img/dataCenterInfrastructure02.004a96f5.png";